import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContractType } from '../classes';
import { ContractService } from '../services/contract.service';

@Pipe({
  name: 'contractType'
})
export class ContractTypePipe implements PipeTransform {

  constructor(private _contractService: ContractService){ }

  transform(typeId: number): Observable<string> {
    if(typeof typeId !== 'number') return of(null);
    return this._contractService.getContractTypeById(typeId, true).pipe(map((type: ContractType) => type.contracttypename));
  }

}
